import { auth, db, storage } from "../../firebaseConfig";
import { doc, setDoc, getDoc } from "firebase/firestore";
import {
  ref,
  uploadBytes,
  getDownloadURL,
  deleteObject,
} from "firebase/storage";

const uploadFileToStorage = async (file) => {
  const user = auth.currentUser;
  if (!user) {
    throw new Error("No authenticated user found.");
  }

  const storagePath = `uploads/${user.uid}/ApplicationDetails/Section6/${file.name}`;
  const storageRef = ref(storage, storagePath);
  await uploadBytes(storageRef, file);
  const downloadURL = await getDownloadURL(storageRef);
  return downloadURL;
};

const deleteFileFromStorage = async (fileName) => {
  const user = auth.currentUser;
  if (!user) {
    // console.error("No authenticated user found. Cannot delete file.");
    return;
  }

  const storagePath = `uploads/${user.uid}/ApplicationDetails/Section6/${fileName}`;
  const fileRef = ref(storage, storagePath);
  try {
    await deleteObject(fileRef);
    // console.log(`Deleted file: ${fileName}`);
  } catch (error) {
    // console.error(`Error deleting file: ${fileName}`, error);
  }
};

export const writeDataS6 = async (formData) => {
  const user = auth.currentUser;
  if (!user) {
    // console.error("No authenticated user found. Cannot write Section 6 data.");
    return;
  }

  try {
    const docRef = doc(
      db,
      "Advisers",
      user.uid,
      "Application Details",
      "Business Conduct",
    );
    const docSnap = await getDoc(docRef);

    // Helper function to process files for a specific section
    const processFiles = async (currentFiles, previousFiles) => {
      if (!currentFiles || currentFiles.length === 0) return [];

      const currentFileNames = new Set(
        currentFiles.map((file) =>
          file instanceof File ? file.name : file.name,
        ),
      );

      const filesToDelete = (previousFiles || []).filter(
        (prevFile) => !currentFileNames.has(prevFile.name),
      );

      await Promise.all(
        filesToDelete.map((file) => deleteFileFromStorage(file.name)),
      );

      return Promise.all(
        currentFiles.map(async (file) => {
          if (file instanceof File) {
            const fileUrl = await uploadFileToStorage(file);
            return { name: file.name, url: fileUrl };
          } else {
            return file;
          }
        }),
      );
    };

    // Previously saved files
    const previousData = docSnap.exists() ? docSnap.data() : {};
    const previousFilesS6_1 = previousData.filesS6_1 || [];
    const previousFilesS6_3 = previousData.filesS6_3 || [];

    // Process files for both sections
    const uploadedFilesS6_1 = await processFiles(
      formData.filesS6_1,
      previousFilesS6_1,
    );
    const uploadedFilesS6_3 = await processFiles(
      formData.filesS6_3,
      previousFilesS6_3,
    );

    const dataToSave = {
      ...formData,
      filesS6_1: uploadedFilesS6_1,
      filesS6_3: uploadedFilesS6_3,
    };

    await setDoc(docRef, dataToSave, { merge: true });
    // console.log("Section 6 data successfully written!");
  } catch (error) {
    // console.error("Error writing Section 6 data to Firestore:", error);
  }
};
